import { FC } from 'react';

import WorkspacePrimitiveEditorModal from '@/shared/components/modals/ResourceCreationModals/WorkspacePrimitiveEditorModal';
import { Tag as WorkspaceTag } from '@/types';

import { isWorkspaceTag, PrimitiveKind, PrimitiveRecord } from '../../types';

interface PrimitiveEditorModalProps {
    initialParentId?: string;
    kind: PrimitiveKind;
    open: boolean;
    record?: PrimitiveRecord;
    tags: WorkspaceTag[];
    onClose: () => void;
}

const PrimitiveEditorModal: FC<PrimitiveEditorModalProps> = ({
    initialParentId,
    kind,
    onClose,
    open,
    record,
    tags,
}): JSX.Element => {
    if (kind === 'tags') {
        return (
            <WorkspacePrimitiveEditorModal
                availableTags={tags}
                initialParentId={initialParentId}
                kind='tag'
                open={open}
                record={isWorkspaceTag(record) ? record : undefined}
                onClose={onClose}
            />
        );
    }

    return (
        <WorkspacePrimitiveEditorModal
            kind='watchlist'
            open={open}
            record={record && !isWorkspaceTag(record) ? record : undefined}
            onClose={onClose}
        />
    );
};

export default PrimitiveEditorModal;
